import { isCordova, isIOS } from '../mobile/deviceDetection';
import { getTrackingPermission } from '../mobile/mobile';
import { getConsent } from './consentState';

/**
 * Stored consent AND platform gate. On iOS, MARKETING additionally requires
 * App Tracking Transparency — ATT governs cross-app tracking (IDFA), which
 * only the advertising vendors touch. First-party statistics/analytics uses
 * no IDFA and therefore only needs the GDPR consent. The ATT prompt is
 * triggered by the banner flow, so by event time the status is determined.
 *
 * @param {'statistics' | 'marketing'} category
 * @returns {Promise<boolean>}
 */
const hasEffectiveConsent = async (category) => {
  const consent = getConsent();
  if (!consent || !consent[category]) return false;
  if (category === 'marketing' && isCordova() && isIOS()) {
    return !!(await getTrackingPermission());
  }
  return true;
};

export default hasEffectiveConsent;
